import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import shortDateFormat from '../../../helpers/dates';
import './CitationList.scss';

const CitationList = ({
  citations,
  title,
}) => (
  <div className="row mt-5 mb-5">
    <h6>{title}</h6>
    <Table striped hover responsive>
      <colgroup>
        <col width="10%" />
        <col width="70%" />
        <col width="20%" />
      </colgroup>
      <thead>
        <tr>
          <th>Type</th>
          <th>Preview</th>
          <th>Added at</th>
        </tr>
      </thead>
      <tbody>
        {citations && citations.length > 0 ? (
          citations.map(item => (
            <tr>
              <td>
                {item.type.name}
              </td>
              <td>
                <span>Title: </span>
                <span className="text-info">{item.title}</span>
                <br />
                <span>Author: </span>
                <span className="text-info">{item.author}</span>
                <br />
                <span>Language: </span>
                <span className="text-info">{item.language || 'Unknown'}</span>
                <br />
                <span>Publisher: </span>
                <span className="text-info">{item.publisher || 'Unknown'}</span>
                <br />
                <span>Edition: </span>
                <span className="text-info">{item.edition || 'Unknown'}</span>
                <br />
                {item.phd ? (
                  <>
                    <span>PhD: </span>
                    <span className="text-info">{item.phd}</span>
                    <br />
                  </>
                ) : null}
                {item.masters ? (
                  <>
                    <span>masters: </span>
                    <span className="text-info">{item.masters || 'Unknown'}</span>
                    <br />
                  </>
                ) : null}
                <span>URL: </span>
                <a href={item.url || '#'} target="_blank" rel="noreferrer">
                  {item.url || 'No URL was added'}
                </a>
              </td>
              <td>{shortDateFormat(item.created_at)}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={3} className="text-center pt-2">This instance doesnt have any citations attached to it.</td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
);

CitationList.propTypes = {
  citations: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
};

CitationList.defaultProps = {

};

export default CitationList;
